import {format} from "date-fns";

export const formatDate = (datetime, showTime = false, showSeconds = false, inputFormat = '') => {
    if (datetime && inputFormat === '-') {
        const dateForm = 'yyyy-MM-dd';
        return format(new Date(datetime), dateForm);
    } else if (datetime && inputFormat === '/') {
        const dateForm = 'MM / dd / yyyy';
        return format(new Date(datetime), dateForm);
    } else if (datetime) {
        const dateForm = 'd.M.yyyy';
        const timeForm = showSeconds ? 'HH:mm:ss' : 'HH:mm';

        return format(new Date(datetime), `${dateForm}${showTime ? ` ${timeForm}` : ''}`);
    }
}

export default formatDate;